import { snippetFeatures } from './snippetUsageModel';
const listeners=new Set();
export const subscribeSnippetCatalogue = listener => { listeners.add(listener); return () => listeners.delete(listener); };
export function bindSnippetCatalogueHints(socket) {
 if (!socket || !snippetFeatures.enabled) return () => {};
 const onEvent=event => { if (event?.event_type==='messaging.catalogue.changed' && event.data?.catalogue==='snippets' && event.data.channel_account_id) listeners.forEach(listener => listener(event.data.channel_account_id)); };
 socket.on('messaging.event',onEvent); return () => socket.off('messaging.event',onEvent);
}
